<template>
    <v-container class="mt-3">
        <v-card flat class="pa-6">
            <div class="text-h3 mb-6 font-weight-bold">
                Contact us
            </div>
            <p>
                The best way to reach us is to e-mail <a href="mailto:support@openalex.org">support@openalex.org</a> and put Unsub somewhere in the subject line.
            </p>


        </v-card>


    </v-container>
</template>

<script>
    export default {
        name: "Press",
        metaInfo() {
            return {
                title: `Contact`
            }
        },
    }
</script>

<style scoped>

</style>
